<ion-card class="price-card ion-no-margin">

  <ion-card-header class="padding-xs">
    <ion-row class="ion-align-items-center">
      <ion-col size="6">
      </ion-col>
      <ion-col size="6" class="ion-text-right" *ngIf="getDiscountPercent() > 0">
        <ion-chip color="warning" class="discount-chip">
          <ion-label class="info-text-mlg bold">-{{ getDiscountPercent() }}% {{ discountLabel }}</ion-label>
        </ion-chip>
      </ion-col>
    </ion-row>
  </ion-card-header>

  <ion-card-content>
    <ion-grid fixed>
      <ion-row>
        <ion-col>
          <span class="offer-title ion-text-center info-text-lg text-color-primary">{{ offerTitle }}</span>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-center ion-align-items-end price-row">
        <ion-col size="auto">
          <ion-text color="medium">
            <span class="old-price info-text-m">{{ formatPriceWithCurrency(regularPrice) }}</span>
          </ion-text>
        </ion-col>
        <ion-col size="auto">
          <ion-text color="warning">
            <span class="new-price info-text-xl">{{ formatPriceWithCurrency(promoPrice) }}</span>
          </ion-text>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="ion-text-center">
          <ion-text color="light">
            <span class="save-line info-text-s text-color-primary">{{ savePrefix }} {{ getSavings() }} {{ saveSuffix }}</span>
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>